import React from 'react'
import Header from './Header'
import Project from './Project'
import "./Projects.css"
import wesdanImg from "./images/wesdan.png"
import youtubeImg from "./images/youtube.png"
import amazonImg from "./images/amazon.png"
import facebookImg from "./images/facebook.png"
import chibidentalImg from "./images/chibi-dental.png"
import weatherImg from "./images/weather.png"
import countdownImg from "./images/countdown.png"

const Projects = () => {
  return (
    <div className="pro">
      

        <div className="projects">
          <h1 className="projects__header">
            My Work
          </h1>

          <div className="project__section">
            <div className="projects__items">
              <Project 
              img={wesdanImg}
              name={"Wesdan Distributors"}
              desc={"E-Commerce Web App"}
              github={"https://github.com/edtech980/Wesdan-Distributors"}
              link={"https://wesdan-catridges.web.app/"}
            />
            </div>

            <div className="projects__items">
              <Project 
              img={weatherImg}
              name={"Weather App"}
              desc={"Full Stack WebApp"}
              github={"https://github.com/edtech980/Weather-App"}
              link={"https://weather-app-3ce2a.web.app/"}
              />
            </div>

            <div className="projects__items">
              <Project 
              img={amazonImg}
              name={"Amazon Clone"}
              desc={"Full Stack E-Commerce WebApp"}
              github={"https://github.com/edtech980/Amazon-Clone/tree/master"}
              link={"https://clone-c5d17.web.app/"}
              />
            </div>
          </div>

          <div className="project__section">
            <div className="projects__items">
              <Project 
              img={countdownImg}
              name={"Countdown APp"}
              desc={"Web APp"}
              github={"https://github.com/edtech980/Countdown-App"}
              link={"https://countdown-app-34d18.web.app/"}
            />
            </div>

            <div className="projects__items">
              <Project 
              img={youtubeImg}
              name={"Youtube Clone"}
              desc={"Full Stack WebApp"}
              github={"https://github.com/edtech980/Youtube-Clone"}
              link={"https://clone-b177f.web.app/"}
              />
            </div>

            <div className="projects__items">
              <Project 
              img={chibidentalImg}
              name={"Chibi Dental"}
              desc={"Dentist Web App"}
              github={"https://github.com/edtech980/Chibi-Dental/tree/master"}
              link={"https://doctor-chibi.web.app/"}
              />
            </div>
          </div>

          <div className="project__section">
            <div className="projects__items">
              <Project 
              img={facebookImg}
              name={"Facebook Clone"}
              desc={"Full Stack WebApp"}
              github={"https://github.com/edtech980/Facebook-Clone"}
              link={"https://facebook-clone-a4c09.web.app/"}
            />
            </div>

  
          </div>

          
        </div>
        
        
      
    </div>
  )
}

export default Projects